import * as React from 'react';
import { toast } from '@grandvisionhq/common';
import { useDeliveryIntervalOptions, DeliveryIntervalSelectView } from '@grandvisionhq/fun-products';
import { useProductDetailContext } from '../../../Context/ProductDetailContext.js';
import { useSolutionsEcommContext } from '../../context/SolutionsEcommContext.js';

/**
 * @deprecated
 */ const SolutionsDeliveryIntervalSelect = ({ className  })=>{
    const { actions , state  } = useSolutionsEcommContext();
    const { deliveryIntervalOptionsFallback  } = useProductDetailContext();
    const { deliveryInterval: deliveryInterval1  } = state.configurations.subscriptionPurchaseConfigurations;
    const { deliveryIntervalOptions , selectedInterval , singleDeliveryIntervalOption  } = useDeliveryIntervalOptions({
        deliveryInterval: deliveryInterval1,
        deliveryIntervalOptionsFallback
    });
    const { deliveryInterval: { showError  } , invalidSubmissionsCount ,  } = state.configurator;
    React.useEffect(()=>{
        if (showError) {
            toast.failed('products.deliveryInterval.error');
        }
    }, [
        showError,
        invalidSubmissionsCount
    ]);
    const handleIntervalSelection = React.useCallback((deliveryInterval)=>actions.updateDeliveryInterval(deliveryInterval)
    , [
        actions
    ]);
    if (!deliveryIntervalOptions) {
        console.error('DeliveryIntervalSelect: No delivery interval options have been set');
        return null;
    }
    return /*#__PURE__*/ React.createElement(DeliveryIntervalSelectView, {
        className: className,
        hasError: showError,
        selectedInterval: selectedInterval,
        singleOptionLabel: singleDeliveryIntervalOption === null || singleDeliveryIntervalOption === void 0 ? void 0 : singleDeliveryIntervalOption.label,
        deliveryIntervalOptions: deliveryIntervalOptions,
        onIntervalSelection: handleIntervalSelection
    });
};

export { SolutionsDeliveryIntervalSelect };
//# sourceMappingURL=SolutionsDeliveryIntervalSelect.js.map
